import { observer } from "mobx-react-lite";
import { Link } from "react-router-dom";
import { useCustomerServiceChatModal } from "../../components/customer-service-chat/CustomerServiceChatModalProvider";
import { CustomerServiceTextEntry } from "../../components/customer-service-chat/CustomerServiceEntry";
import { STANDALONE_FOOTER } from "./standaloneFooterContent";
import "./StandaloneFooter.css";

/** Tactik 独立站底栏 */
export const StandaloneFooter = observer(function StandaloneFooter() {
  const cs = useCustomerServiceChatModal();
  const icpBody = STANDALONE_FOOTER.icpLabel || "待补充";
  const policeBody = STANDALONE_FOOTER.policeLabel || "待补充";

  return (
    <footer className="standalone-footer" role="contentinfo">
      <nav className="standalone-footer-nav" aria-label="法律与平台规则">
        <Link className="standalone-footer-link" to="/legal/user-agreement">
          用户协议
        </Link>
        <span className="standalone-footer-sep" aria-hidden>
          |
        </span>
        <Link className="standalone-footer-link" to="/legal/privacy">
          隐私政策
        </Link>
        <span className="standalone-footer-sep" aria-hidden>
          |
        </span>
        <Link className="standalone-footer-link" to="/legal/compliance">
          法律合规
        </Link>
        <span className="standalone-footer-sep" aria-hidden>
          |
        </span>
        <CustomerServiceTextEntry
          className="standalone-footer-link"
          onClick={cs.openCustomerServiceChat}
        />
      </nav>
      <p
        className="standalone-footer-meta"
        role="group"
        aria-label="公司主体与备案信息"
      >
        <span className="standalone-footer-company-inrow">
          {STANDALONE_FOOTER.companyName}
        </span>
        <span className="standalone-footer-sep" aria-hidden>
          |
        </span>
        <span>
          <span className="standalone-footer-beian-label">ICP 许可证：</span>
          {STANDALONE_FOOTER.icpLabel ? (
            <a
              className="standalone-footer-link"
              href={STANDALONE_FOOTER.icpQueryUrl}
              target="_blank"
              rel="noreferrer noopener"
            >
              {icpBody}
            </a>
          ) : (
            <span className="standalone-footer-beian-pending">{icpBody}</span>
          )}
        </span>
        <span className="standalone-footer-sep" aria-hidden>
          |
        </span>
        <span>
          <span className="standalone-footer-beian-label">公安网备：</span>
          {STANDALONE_FOOTER.policeLabel ? (
            <a
              className="standalone-footer-link"
              href={STANDALONE_FOOTER.policeQueryUrl}
              target="_blank"
              rel="noreferrer noopener"
            >
              {policeBody}
            </a>
          ) : (
            <span className="standalone-footer-beian-pending">{policeBody}</span>
          )}
        </span>
      </p>
    </footer>
  );
});
